import INFTCollections from '../../models/INFTCollections'
import AvawareAllenCard from '../../nftFormats/AvawareAllen/Card/AvawareAllenCard'
import AvawareAllenDetail from '../../nftFormats/AvawareAllen/Detail/AvawareAllenDetail'
import AvawareAllenActivtyDetail from '../../nftFormats/AvawareAllen/Activity/AvawareAllenActivtyDetail'

import AvalancheFriends1Logo from '../../../../assets/nft-logo/AvalancheFriends1.jpg'
import AvalancheFriends2Logo from '../../../../assets/nft-logo/AvalancheFriends2.jpg'
import AvalancheFriends3Logo from '../../../../assets/nft-logo/AvalancheFriends3.jpg'
import AvalancheFriends4Logo from '../../../../assets/nft-logo/AvalancheFriends4.jpg'
import AvalancheFriends5Logo from '../../../../assets/nft-logo/AvalancheFriends5.jpg'
import AvalancheFriends6Logo from '../../../../assets/nft-logo/AvalancheFriends6.jpg'
import AvalancheFriends7Logo from '../../../../assets/nft-logo/AvalancheFriends7.jpg'
import AvalancheFriends8Logo from '../../../../assets/nft-logo/AvalancheFriends8.jpg'
import AvalancheFriends9Logo from '../../../../assets/nft-logo/AvalancheFriends9.jpg'
import AvalancheFriends10Logo from '../../../../assets/nft-logo/AvalancheFriends10.jpg'
import AvalancheFriends11Logo from '../../../../assets/nft-logo/AvalancheFriends11.jpg'
import AvalancheFriends12Logo from '../../../../assets/nft-logo/AvalancheFriends12.jpg'
import AvalancheFriends13Logo from '../../../../assets/nft-logo/AvalancheFriends13.jpg'


const social = {
  website: 'https://avaware.network/nft',
  twitter: 'AvawareAVE',
  telegram: 'https://t.me/avavaware',
  discord: 'https://discord.com/invite/B8RTbe4yur'
}

export const AvalancheFriendsData: INFTCollections[] = [
  {
    id: 'AvalancheFriends1',
    tokenAddress: '0x9b29ffdd69cdad3ac99ce9560f8e433332ce908e',
    name: 'Pann The Pangolin',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends1Logo,
    ...social
  },
  {
    id: 'AvalancheFriends2',
    tokenAddress: '0x613dc313d88f30e2d9c08817e77d3852681aebf2',
    name: 'Yarley The Yak',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends2Logo,
    ...social
  },
  {
    id: 'AvalancheFriends3',
    tokenAddress: '0x29794d757bafb674890d52fc2c7ad0c1e17a278b',
    name: 'Eddy The Elk',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends3Logo,
    ...social
  },
  {
    id: 'AvalancheFriends4',
    tokenAddress: '0x7990c712b2b4873c78122a88400caa816ac83c92',
    name: 'Sam The Sasquatch',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends4Logo,
    ...social
  },
  {
    id: 'AvalancheFriends5',
    tokenAddress: '0x33dd2df1cb1159ec59e3a9a8213604d27edb7045',
    name: 'Carl The Cabbage',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends5Logo,
    ...social
  },
  {
    id: 'AvalancheFriends6',
    tokenAddress: '0xec53866d346be5e9c80a0a1b79797e18f056b20a',
    name: 'Cyrus The Cyclone',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends6Logo,
    ...social
  },
  {
    id: 'AvalancheFriends7',
    tokenAddress: '0x6ffbd2965da53a8c0ce32944fad99b700ac0f70c',
    name: 'Pep The Penguin',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends7Logo,
    ...social
  },
  {
    id: 'AvalancheFriends8',
    tokenAddress: '0xc6a02823e3001c3c625d77babf299cd76182b174',
    name: 'Rex Rawlins Of RPPD',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends8Logo,
    ...social
  },
  {
    id: 'AvalancheFriends9',
    tokenAddress: '0xb463df8ca8a58640cbf2f0faa4013a99a43dc96b',
    name: 'Corra The Canary',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends9Logo,
    ...social
  },
  {
    id: 'AvalancheFriends10',
    tokenAddress: '0xc2d8600d60582605bb3349a7049ea02330df9024',
    name: 'Simon The Sherpa',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends10Logo,
    ...social
  },
  {
    id: 'AvalancheFriends11',
    tokenAddress: '0x4744823ae546f253f4941b8cc62a6ec3439998d2',
    name: 'The Trading Joe',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends11Logo,
    ...social
  },
  {
    id: 'AvalancheFriends12',
    tokenAddress: '0x76e07b12fa52104442a0dfa9b899d58c56df631c',
    name: 'Yule The Yeti',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends12Logo,
    ...social
  },
  {
    id: 'AvalancheFriends13',
    tokenAddress: '0x005e1638b8cab22d7ce1db9312966f7e7a7e768d',
    name: 'Sloan The Snowman',
    cardFormat: AvawareAllenCard,
    detailFormat: AvawareAllenDetail,
    activityFormat: AvawareAllenActivtyDetail,
    category: 1,
    creatorAddress: '0x332342f1bfDFFcF449b38e3dD2b0Dcd09c939a98',
    logo: AvalancheFriends13Logo,
    ...social
  }
]

export const AvalancheFriendsCategoryData = {
  [AvalancheFriendsData[0].tokenAddress.toLowerCase()]: AvalancheFriendsData[0].category,
  [AvalancheFriendsData[1].tokenAddress.toLowerCase()]: AvalancheFriendsData[1].category,
  [AvalancheFriendsData[2].tokenAddress.toLowerCase()]: AvalancheFriendsData[2].category,
  [AvalancheFriendsData[3].tokenAddress.toLowerCase()]: AvalancheFriendsData[3].category,
  [AvalancheFriendsData[4].tokenAddress.toLowerCase()]: AvalancheFriendsData[4].category,
  [AvalancheFriendsData[5].tokenAddress.toLowerCase()]: AvalancheFriendsData[5].category,
  [AvalancheFriendsData[6].tokenAddress.toLowerCase()]: AvalancheFriendsData[6].category,
  [AvalancheFriendsData[7].tokenAddress.toLowerCase()]: AvalancheFriendsData[7].category,
  [AvalancheFriendsData[8].tokenAddress.toLowerCase()]: AvalancheFriendsData[8].category,
  [AvalancheFriendsData[9].tokenAddress.toLowerCase()]: AvalancheFriendsData[9].category,
  [AvalancheFriendsData[10].tokenAddress.toLowerCase()]: AvalancheFriendsData[10].category,
  [AvalancheFriendsData[11].tokenAddress.toLowerCase()]: AvalancheFriendsData[11].category,
  [AvalancheFriendsData[12].tokenAddress.toLowerCase()]: AvalancheFriendsData[12].category
}
